/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Create_SubmitInputs */

const en_statement_tree_create_submit = /** @type {(inputs: Statement_Tree_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create statement tree`)
};

const nl_statement_tree_create_submit = /** @type {(inputs: Statement_Tree_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stamboom aanmaken`)
};

/**
* | output |
* | --- |
* | "Create statement tree" |
*
* @param {Statement_Tree_Create_SubmitInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_create_submit = /** @type {((inputs?: Statement_Tree_Create_SubmitInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Create_SubmitInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_create_submit(inputs)
	return en_statement_tree_create_submit(inputs)
});